import { createSlice } from "@reduxjs/toolkit"

import {
  getAllMenuSetup,
  getMenusWithoutPagination,
  getMenuSetup,
  getMenuByBrandandCountry,
} from "store/actions/menuSetupAction"

const initialState = {
  loading: true,
  isLoading: false,
  itemsPerPage: 10,
  totalPages: null,
  currentPage: 1,
  totalCount: null,
  menus: [],
  allMenus: [],
  singleMenuSetup: null,
  menusByCountryandBrands: [],
}

const menuSetupSlice = createSlice({
  name: "menu setup",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllMenuSetup.pending, state => {
        state.loading = true
      })
      .addCase(getAllMenuSetup.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload || {}
        if (status) {
          const { totalCount, totalPages, currentPage, data: menus } = data

          state.menus = menus
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getAllMenuSetup.rejected, (state, action) => {
        state.loading = false
      })
      .addCase(getMenusWithoutPagination.pending, state => {
        state.isLoading = true
      })
      .addCase(getMenusWithoutPagination.fulfilled, (state, action) => {
        state.isLoading = false
        const { status, data } = action.payload || {}
        if (status) {
          state.allMenus = data
        }
      })
      .addCase(getMenusWithoutPagination.rejected, state => {
        state.isLoading = false
      })
      .addCase(getMenuSetup.pending, state => {
        state.isLoading = true
      })
      .addCase(getMenuSetup.fulfilled, (state, action) => {
        state.isLoading = false
        const { status, data } = action.payload || {}

        if (status) {
          state.singleMenuSetup = data
        }
      })
      .addCase(getMenuSetup.rejected, state => {
        state.isLoading = false
      })

      .addCase(getMenuByBrandandCountry.pending, state => {
        state.isLoading = true
      })
      .addCase(getMenuByBrandandCountry.fulfilled, (state, action) => {
        state.isLoading = false
        const { status, data } = action.payload || {}
        if (status) {
          state.menusByCountryandBrands = data
        }
      })
      .addCase(getMenuByBrandandCountry.rejected, state => {
        state.isLoading = false
      })
  },
})

export default menuSetupSlice.reducer
